import React from "react";
import Button from '../Components/Button'
import { bankCodeWriting, GetParamsData } from '$Deposits/lib/LibCommonData'
import Modal from "./Modal";
import UserBankSelectCon from '$Deposits/Components/Components/UserBankSelect'
import { connect } from "react-redux";

import { SetReverseBankDefault, SetDepositMemberBanksActive } from '$Deposits/store/actions/DepositAction'
import Select, { Option } from "rc-select";

class UserBankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { allowChange, step } = this.props;


        return (
            <>
                <UserBankSelectCon
                    UserBankSelect={(propCon) => {
                        const {
                            onChange,
                            DepositMemberBanksActive,
                            BankList,
                            AddBankClick,
                            methods,
                            RD_Icon,
                            RD_isReverseDeposit,
                            showAddUserBank,
                            RD_Disabled
                        } = propCon
                        return (
                            <BankDrawerRedux
                                onChange={onChange}
                                DepositMemberBanksActive={DepositMemberBanksActive}
                                BankList={BankList}
                                AddBankClick={AddBankClick}
                                methods={methods}
                                RD_Icon={RD_Icon}
                                showAddUserBank={showAddUserBank}
                                RD_Disabled={RD_Disabled}
                                RD_isReverseDeposit={RD_isReverseDeposit}
                                allowChange={allowChange}
                                step={step}
                            />
                        )
                    }}

                />



            </>
        );
    }
}

export default UserBankSelect

class BankDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeBank: this.props.DepositMemberBanksActive || {},
            RD_Modal: false,
            isChange: false
        };

    }

    componentDidUpdate(prevProps, prevState){
        const { webPiwikUrl } = GetParamsData()
        const {RD_Modal} = this.state;
        if(prevState.RD_Modal!==RD_Modal ){
            if(RD_Modal){
                webPiwikUrl("express_deposit_changebank_reminder_popup", "Express Deposit reminder Popup")
            }else{
                webPiwikUrl("deposit_rd", "RD Deposit Page")
            }
        }
    }
    render() {

        const { activeBank, RD_Modal, isChange } = this.state

        const { webPiwikEvent } = GetParamsData()

        const {
            onChange,
            DepositMemberBanksActive,
            BankList,
            AddBankClick,
            showAddUserBank,
            methods,
            RD_Icon,
            RD_Disabled,
            RD_isReverseDeposit,
            MethodsActive,
            MethodCodeActive,
            allowChange,
            SetReverseBankDefault,
            SetDepositMemberBanksActive,
            step
        } = this.props;
        const { code } = DepositMemberBanksActive || {}
        const { bankAccountID, bankNameEn, bankName, accountNumber } = activeBank || {}
        return (
            <>
                <Modal
                    className='modalTips'
                    visible={RD_Modal}
                    title={'ยืนยันการเปลี่ยนบัญชีธนาคาร'}
                    cancelText={'ปิด'}
                    okText={'ยืนยันเปลี่ยนบัญชี'}
                    onCancel={() => { this.setState({RD_Modal: false}) }}
                    onOk={() => { this.setState({RD_Modal: false, isChange: true}, () => document.querySelector("#dropdown").click()); }}
                >
                    <>
                        <div className='titleIcon'>
                            <div className={`warningIcon imgIcon`} />
                        </div>
                        <p className="intro introCenter">{`การเปลี่ยนบัญชีจะมีผลต่อบัญชีที่ใช้ในการฝาก \n คุณต้องใช้ธนาคารที่เปลี่ยนในการฝากเงินเท่านั้น`}</p>
                    </>
                </Modal>
                <p className="inputTitle" data-CN="收款銀行帳號">เลขที่บัญชีสมาชิก</p>
                {
                    !RD_Disabled && BankList.length == 0 &&
                    <Button
                        ghost
                        className="addBankBtn"
                        data-CN="新增銀行帳號"
                        onClick={() => {
                            if(MethodsActive.code==="LB"){
                                webPiwikEvent("Deposit", "Add New Bank Account", `Deposit_LB_C_${MethodCodeActive}_AddBank`)
                            }
                            AddBankClick()
                        }}
                    >
                        เพิ่มบัญชีธนาคาร
                    </Button>
                }
                {
                    !RD_Disabled && !allowChange && BankList.length > 0 &&
                    <div className="drop-area">
                        <Select
                            showSearch={false}
                            value={code}
                            optionLabelProp="children"
                            onChange={(v) => {
                                if(v != '') {
                                    const bank = BankList.find((item) => {
                                        return item.code == v
                                    })
                                    onChange(bank)
                                }
                            }}
                            getPopupContainer={() =>
                                document.querySelector(".drop-area")
                            }
                            suffixIcon={
                                <span className="drawerIcon"/>
                            }
                        >
                            {
                                BankList.map((value, index) => {
                                    return (
                                        <Option
                                            value={value.code}
                                            key={value.code + index}
                                        >
                                            <span
                                                className={'bankIcon-default bankIcon-' + bankCodeWriting(value.bankNameEn)}/>
                                            <p className="inputViewName">{(value.bankNameLocal || value.bankNameEn) + " " + value.accountNumber.replace(/.(?=.{3})/g, "*")}</p>
                                            {/*<span className="drawerIcon" />*/}
                                        </Option>
                                    )
                                })
                            }
                            {showAddUserBank && <Option
                                value={''}
                                key={'add'}
                            >
                                <Button
                                    ghost
                                    data-CN="新增銀行帳號"
                                    className="select-dropdown-button"
                                    onClick={(e) => {
                                        if(MethodsActive.code==="LB"){
                                            webPiwikEvent("Deposit", "Add New Bank Account", `Deposit_LB_C_${MethodCodeActive}_AddBank`)
                                        }
                                        AddBankClick()
                                    }}
                                >
                                    เพิ่มบัญชีธนาคาร
                                </Button>
                            </Option>}
                        </Select>
                    </div>}

                {
                    !RD_Disabled && allowChange && BankList.length > 0 &&
                    <div className="drop-area">
                        <Select
                            id="dropdown"
                            showSearch={false}
                            value={code}
                            optionLabelProp="children"
                            disabled={!isChange}
                            inputIcon={!isChange ? <span className="blueText" onClick={() => this.setState({
                                RD_Modal: step == 2 ? true : false,
                                isChange: step == 1 ? true: false
                            }, () => document.querySelector("#dropdown").click())}>เปลี่ยน</span> : null}
                            onSelect={(val) => {
                                if(DepositMemberBanksActive.code == val)
                                    return
                                if(allowChange && step == 1)
                                    SetDepositMemberBanksActive(BankList.find(x => x.code == val) || {})
                                else
                                    SetReverseBankDefault(val || '')
                                this.setState({
                                    isChange: false
                                })
                            }}
                        >
                            {
                                BankList.map((value, index) => {
                                    return (
                                        <Option
                                            value={value.code}
                                            key={value.code + index}
                                        >
                                            <span
                                                className={'bankIcon-default bankIcon-' + bankCodeWriting(value.bankNameEn)}/>
                                            <p className="inputViewName">{(value.bankNameLocal || value.bankNameEn) + " " + value.accountNumber.replace(/.(?=.{3})/g, "*")}</p>
                                            {/*<span className="drawerIcon" />*/}
                                        </Option>
                                    )
                                })
                            }
                            {showAddUserBank && <Option
                                value={''}
                                key={'add'}
                            >
                                <Button
                                    ghost
                                    data-CN="新增銀行帳號"
                                    className="select-dropdown-button"
                                    onClick={(e) => {
                                        if(MethodsActive.code==="LB"){
                                            webPiwikEvent("Deposit", "Add New Bank Account", `Deposit_LB_C_${MethodCodeActive}_AddBank`)
                                        }
                                        AddBankClick()
                                    }}
                                >
                                    เพิ่มบัญชีธนาคาร
                                </Button>
                            </Option>}
                        </Select>
                    </div>
                }

                {
                    RD_Disabled &&
                    <div className="drop-area">
                        <Select
                            showSearch={false}
                            value={code}
                            optionLabelProp="children"
                            className='disabled'
                            disabled
                            showArrow={false}
                        >
                            <Option
                                value={DepositMemberBanksActive.code}
                                key={DepositMemberBanksActive.code}
                            >
                                <span
                                    className={'bankIcon-default bankIcon-' + bankCodeWriting(DepositMemberBanksActive.bankNameEn)}/>
                                <p className="inputViewName">{(DepositMemberBanksActive.bankNameLocal || DepositMemberBanksActive.bankNameEn) + " " + DepositMemberBanksActive.accountNumber.replace(/.(?=.{3})/g, "*")}</p>
                                {/*<span className="drawerIcon" />*/}
                            </Option>
                        </Select>
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    MethodCodeActive: state.MethodCodeActive,
});
const mapDispatchToProps = {
    SetReverseBankDefault: (data) => SetReverseBankDefault(data),
    SetDepositMemberBanksActive: (data = {}) => SetDepositMemberBanksActive(data),
};
export const BankDrawerRedux = connect(mapStateToProps, mapDispatchToProps)(BankDrawer);
